<template>
  <div class="hero-video-placeholder">
    <content-loader
      class="d-none d-lg-block"
      primary-color="#DEB1FD"
      secondary-color="#cccccc"
      :primary-opacity="0.6"
      :secondary-opacity="0.5"
      width="882"
      height="514"
      viewBox="0 0 882 514"
    >
      <rect x="0" y="0" width="882" height="514" />
    </content-loader>
    <content-loader
      class="d-lg-none"
      primary-color="#DEB1FD"
      secondary-color="#cccccc"
      :primary-opacity="0.6"
      :secondary-opacity="0.5"
      :width="width"
      :height="totalHeight"
    >
      <rect x="0" y="0" :width="width" :height="videoHeight" />
      <rect x="0" :y="videoHeight + gap" :width="width" :height="labelHeight" />
    </content-loader>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { ContentLoader } from "vue-content-loader";

defineOptions({
  name: "hero-video-placeholder",
});

const width = ref(window.innerWidth);
const gap = ref(2);
const labelHeight = ref(66);

const videoHeight = computed(() => {
  return width.value / (16 / 9);
});

const totalHeight = computed(() => {
  return videoHeight.value + gap.value + labelHeight.value;
});

const onResize = () => {
  width.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener("resize", onResize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", onResize);
});
</script>
